import { TextField } from '@mui/material';
import styles from './comment-input.module.scss';
import { FC, useContext, useState } from 'react';
import { TComment } from '../../../models/common';
import Button from 'components/atoms/button/button';
import { useNavigate } from 'react-router-dom';
import { UserContext } from 'contexts/userContext';

interface CommentInputProps {
  comments?: Array<TComment | undefined>;
  onPost: (message: string) => void;
}
const CommentInput: FC<CommentInputProps> = ({ comments, onPost }) => {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  
  const [message, setMessage] = useState('');
  const isButtonDisabled = !message.trim().length;

  const handleClickPost = () => {
    onPost(message);
    setMessage('');
  };

  const handleClickLogin = () => {
    navigate('/login')
  }

  return (
    <div className={`${styles.commentInput} ${comments?.[1] && styles.reply}`}>
      {user._id ? (
        <>
          <TextField
            onChange={(e) => setMessage(e.target.value)}
            value={message}
            placeholder="What are your thoughts?"
            fullWidth
            variant="outlined"
            InputProps={{
              style: {
                borderRadius: '0.5rem',
                fontSize: '0.875rem',
              },
            }}
          />
          <Button
            type="primary"
            onClick={handleClickPost}
            disabled={isButtonDisabled}
            radius="2rem"
          >
            Post
          </Button>
        </>
      ) : (
        <div className={styles.login}>
          <span>Post a comment</span>

          <Button
            radius="0.5rem"
            type="primaryOutline"
            onClick={handleClickLogin}
          >
            Log in
          </Button>
        </div>
      )}
    </div>
  );
};

export default CommentInput;
